/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectsService {
    /**
     * next project number
     * @param tenantId tenant_id
     * @returns any successful
     * @throws ApiError
     */
    public static getNextProjectNumber(
        tenantId: string,
    ): CancelablePromise<{
        next_number?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/next_number',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
